import style from "./styles.module.css";

const Counter = ({ count, decrement, increment }) => {
    return (
        <div className={style.cart_counter_block}>
            <button onClick={decrement} className={style.counterBtn}>
                <svg
                    width="14"
                    height="2"
                    viewBox="0 0 14 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0.71875 1.07764H13.4372" stroke="var(--black)"></path>
                </svg>
            </button>
            <span>{count}</span>
            <button
                onClick={increment}
                className={style.counterBtn}
                style={{
                    backgroundColor: '#D30000',
                    border: 'none',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path d="M0 6.35922H12.7184M6.35922 0L6.35922 12.7184" stroke="white"/>
                </svg>
            </button>
        </div>
    );
};

export default Counter;
